(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purogyn-bewertungen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('purogyn-reviews')) {
    customElements.define('purogyn-reviews', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.scrollTimer);
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.removeAttribute('data-ready');
      }

      setup() {
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        if (!this.track || !this.cards.length || !this.isConnected) return;
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.controls = this.querySelector('[data-controls]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.current = this.querySelector('[data-current]');
        this.total = this.querySelector('[data-total]');
        this.dots = this.querySelector('[data-dots]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activePage = 0;
        this.targetPage = null;
        this.positions = [];
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.sync());
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => { this.targetPage = null; this.sync(); }, 180);
        }, { passive: true, signal });
        this.track.addEventListener('pointerdown', () => { this.targetPage = null; }, { passive: true, signal });
        this.track.addEventListener('wheel', () => { this.targetPage = null; }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const nextKey = this.rtl ? 'ArrowLeft' : 'ArrowRight';
          const previousKey = this.rtl ? 'ArrowRight' : 'ArrowLeft';
          if (event.key === nextKey || event.key === previousKey) {
            event.preventDefault();
            this.move(event.key === nextKey ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.positions.length - 1);
          }
        }, { signal });
        this.dots?.addEventListener('click', event => {
          const button = event.target.closest('[data-page]');
          if (button && this.dots.contains(button)) this.goTo(Number(button.dataset.page));
        }, { signal });
        this.ownerDocument.addEventListener('shopify:block:select', event => {
          const card = event.target.closest?.('[data-review-card]');
          if (!card || !this.contains(card)) return;
          const index = this.cards.indexOf(card);
          if (index < 0) return;
          this.refresh();
          const rect = card.getBoundingClientRect();
          const viewport = this.track.getBoundingClientRect();
          const start = this.rtl ? viewport.right - rect.right : rect.left - viewport.left;
          const position = Math.max(0, Math.min(this.maxScroll, this.readScroll() + start));
          this.targetPage = null;
          this.track.scrollTo({ left: this.rtl ? -position : position, behavior: 'auto' });
        }, { signal });
        this.refresh();
        this.setAttribute('data-ready', '');
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.refresh());
          });
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.refresh(), { signal });
        }
      }

      readScroll() {
        return Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft);
      }

      refresh() {
        if (!this.isConnected) return;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const viewport = this.track.getBoundingClientRect();
        const offset = this.readScroll();
        const positions = [0];
        for (const card of this.cards) {
          const rect = card.getBoundingClientRect();
          const start = this.rtl ? viewport.right - rect.right : rect.left - viewport.left;
          const position = Math.max(0, Math.min(this.maxScroll, offset + start));
          if (position - positions[positions.length - 1] > 2) positions.push(position);
        }
        if (this.maxScroll - positions[positions.length - 1] > 2) positions.push(this.maxScroll);
        const countChanged = positions.length !== this.positions.length;
        this.positions = positions;
        this.targetPage = null;
        const overflow = this.maxScroll > 2;
        this.controls.hidden = !overflow;
        this.total.textContent = String(positions.length);
        if (this.dots) {
          this.dots.hidden = !overflow;
          if (countChanged) {
            this.dots.replaceChildren();
            positions.forEach((_, index) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'pgr__dot';
              button.dataset.page = String(index);
              button.setAttribute('aria-label', `Ansicht ${index + 1} anzeigen`);
              button.setAttribute('aria-controls', this.track.id);
              this.dots.append(button);
            });
          }
        }
        this.sync();
      }

      sync() {
        if (!this.positions.length) return;
        const offset = this.readScroll();
        let closest = 0;
        this.positions.forEach((position, index) => {
          if (Math.abs(position - offset) < Math.abs(this.positions[closest] - offset)) closest = index;
        });
        this.activePage = closest;
        const label = String(closest + 1);
        if (this.current.textContent !== label) this.current.textContent = label;
        this.previous.disabled = offset <= 2;
        this.next.disabled = offset >= this.maxScroll - 2;
        this.dots?.querySelectorAll('[data-page]').forEach((button, index) => {
          if (index === closest) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      }

      move(direction) {
        this.goTo((this.targetPage ?? this.activePage) + direction);
      }

      goTo(index) {
        const target = Math.max(0, Math.min(this.positions.length - 1, index));
        this.targetPage = target;
        const position = this.positions[target];
        this.track.scrollTo({ left: this.rtl ? -position : position, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
